var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	52950: () => (loadStrictSingletonVersion("default", "@angular/core", false, [1,19,2,0], () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	17796: () => (loadStrictSingletonVersion("default", "@angular/common", false, [1,19,2,0], () => (__webpack_require__.e(7935).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	32778: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e(8219).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	44866: () => (loadStrictSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	53358: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/signals", false, [1,19,2,0], () => (__webpack_require__.e(8070).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	57576: () => (loadStrictSingletonVersion("default", "@angular/core/primitives/di", false, [1,19,2,0], () => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))),
	1014: () => (loadStrictSingletonVersion("default", "@angular/forms", false, [1,19,2,0], () => (__webpack_require__.e(4456).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	1420: () => (loadStrictSingletonVersion("default", "@angular/cdk/platform", false, [1,19,2,19], () => (__webpack_require__.e(80).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))))),
	18298: () => (loadStrictSingletonVersion("default", "@angular/cdk/private", false, [1,19,2,19], () => (__webpack_require__.e(1608).then(() => (() => (__webpack_require__(/*! @angular/cdk/private */ 9227))))))),
	53140: () => (loadStrictSingletonVersion("default", "@angular/cdk/a11y", false, [1,19,2,19], () => (__webpack_require__.e(9721).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))))),
	64788: () => (loadStrictSingletonVersion("default", "@angular/cdk/bidi", false, [1,19,2,19], () => (__webpack_require__.e(1299).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))))),
	74924: () => (loadStrictSingletonVersion("default", "@angular/cdk/coercion", false, [1,19,2,19], () => (__webpack_require__.e(433).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))))),
	11288: () => (loadStrictSingletonVersion("default", "@angular/cdk/keycodes", false, [1,19,2,19], () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))))),
	29890: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers/private", false, [1,19,2,19], () => (__webpack_require__.e(996).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 98615))))))),
	30734: () => (loadStrictSingletonVersion("default", "@angular/cdk/scrolling", false, [1,19,2,19], () => (__webpack_require__.e(2356).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))))),
	50568: () => (loadStrictSingletonVersion("default", "@angular/cdk/portal", false, [1,19,2,19], () => (__webpack_require__.e(9168).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))))),
	56428: () => (loadSingleton("default", "@angular/cdk/overlay", false, () => (__webpack_require__.e(9189).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))))),
	5130: () => (loadStrictSingletonVersion("default", "@angular/cdk/observers", false, [1,19,2,19], () => (__webpack_require__.e(1920).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 39539))))))),
	40992: () => (loadStrictVersion("default", "@angular/common/http", false, [1,"auto"], () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	81307: () => (loadStrictSingletonVersion("default", "@angular/platform-browser", false, [1,19,2,0], () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	76144: () => (loadSingleton("default", "@angular/cdk/text-field", false, () => (__webpack_require__.e(7559).then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 69940))))))),
	1474: () => (loadStrictSingletonVersion("default", "@angular/cdk/collections", false, [1,19,2,19], () => (__webpack_require__.e(370).then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 37989))))))),
	95399: () => (loadStrictSingletonVersion("default", "@angular/animations/browser", false, [1,19,2,14], () => (__webpack_require__.e(655).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))))),
	4066: () => (loadStrictSingletonVersion("default", "@angular/core/rxjs-interop", false, [1,19,2,0], () => (__webpack_require__.e(6693).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))))),
	25945: () => (loadStrictSingletonVersion("default", "ngx-quill/config", false, [1,25,3,3], () => (__webpack_require__.e(6295).then(() => (() => (__webpack_require__(/*! ngx-quill/config */ 68676))))))),
	86583: () => (loadStrictSingletonVersion("default", "apexcharts", false, [1,3,45,2], () => (__webpack_require__.e(1633).then(() => (() => (__webpack_require__(/*! apexcharts */ 31633))))))),
	80088: () => (loadStrictSingletonVersion("default", "quill", false, [1,2,0,3], () => (__webpack_require__.e(3890).then(() => (() => (__webpack_require__(/*! quill */ 83890)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"80": [
		17796
	],
	"88": [
		80088
	],
	"316": [
		44866,
		52950
	],
	"370": [
		44866
	],
	"436": [
		17796,
		40992,
		52950
	],
	"604": [
		1420,
		5130,
		11288,
		18298,
		29890,
		30734,
		32778,
		44866,
		50568,
		52950,
		53140,
		64788,
		74924
	],
	"1208": [
		1014,
		1420,
		18298,
		52950,
		53140,
		64788,
		74924
	],
	"1299": [
		17796
	],
	"1423": [
		1014,
		1420,
		1474,
		18298,
		52950,
		53140,
		64788,
		74924
	],
	"1459": [
		17796,
		32778,
		40992,
		44866,
		52950,
		53140,
		64788,
		81307
	],
	"1570": [
		17796,
		32778,
		44866,
		52950
	],
	"2075": [
		17796,
		32778,
		44866,
		52950
	],
	"2102": [
		17796,
		32778,
		44866,
		52950
	],
	"2243": [
		1014,
		1420,
		1474,
		5130,
		11288,
		17796,
		18298,
		29890,
		30734,
		32778,
		44866,
		50568,
		52950,
		53140,
		56428,
		64788,
		74924
	],
	"2265": [
		1420,
		11288,
		17796,
		18298,
		32778,
		44866,
		52950,
		53140,
		64788,
		74924
	],
	"2356": [
		17796
	],
	"2569": [
		1420,
		5130,
		17796,
		29890,
		32778,
		44866,
		52950,
		53140,
		64788,
		74924
	],
	"2691": [
		17796,
		32778,
		44866,
		52950,
		81307
	],
	"2814": [
		52950
	],
	"3036": [
		52950
	],
	"3680": [
		17796,
		52950
	],
	"3835": [
		17796,
		52950,
		95399
	],
	"4358": [
		1014,
		1420,
		11288,
		17796,
		18298,
		29890,
		30734,
		32778,
		44866,
		50568,
		52950,
		53140,
		56428,
		64788,
		74924
	],
	"4422": [
		1014,
		4066,
		17796,
		25945,
		32778,
		44866,
		52950,
		81307
	],
	"4456": [
		17796,
		32778,
		44866
	],
	"4643": [
		1014,
		1420,
		18298,
		52950,
		53140,
		64788,
		74924
	],
	"5498": [
		17796,
		44866,
		52950
	],
	"6443": [
		32778,
		44866,
		52950
	],
	"6583": [
		86583
	],
	"6787": [
		17796,
		52950
	],
	"7556": [
		1014,
		1420,
		1474,
		5130,
		11288,
		17796,
		18298,
		29890,
		30734,
		32778,
		44866,
		52950,
		53140,
		56428,
		64788,
		74924
	],
	"7580": [
		32778,
		44866,
		53358,
		57576
	],
	"7699": [
		17796,
		52950
	],
	"7913": [
		1014,
		1420,
		11288,
		17796,
		18298,
		29890,
		30734,
		32778,
		44866,
		50568,
		52950,
		53140,
		56428,
		64788,
		74924
	],
	"7922": [
		1014,
		1420,
		5130,
		17796,
		29890,
		32778,
		44866,
		52950,
		53140,
		64788,
		74924,
		76144
	],
	"7935": [
		44866
	],
	"7989": [
		44866,
		52950
	],
	"8055": [
		17796,
		40992
	],
	"8615": [
		32778,
		44866,
		52950
	],
	"8676": [
		52950
	],
	"8824": [
		32778,
		44866
	],
	"9074": [
		32778,
		44866,
		52950
	],
	"9168": [
		17796
	],
	"9227": [
		52950
	],
	"9539": [
		32778,
		44866,
		52950
	],
	"9721": [
		17796,
		32778,
		44866
	],
	"9940": [
		17796,
		32778,
		44866,
		52950
	],
	"9975": [
		17796,
		32778,
		44866,
		52950
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}